import { HttpRequest } from './HttpRequest';
import { baseUrl, bulkQuotationUrl } from 'utils/ApiRoutes';

/**
 * Cotización masiva interna (solo admin). Usa el token de Cognito vía
 * HttpRequest. Contrato: packages/api/docs/contrato-cotizacion-masiva-interna.md
 */

/**
 * POST /crearCotizacionLoteInterno — crea 1..N cotizaciones en una llamada.
 */
export const createBulkQuotation = async (
  body: IBulkQuoteBody
): Promise<IBulkQuoteCreateResponse> => {
  const response = await new HttpRequest().Post<IBulkQuoteCreateResponse>(
    `${baseUrl}${bulkQuotationUrl.create}`,
    body
  );
  return response.data;
};

/**
 * GET /cotizacionLoteInterno/{batchId} — estado agregado de todo el lote.
 */
export const getBulkQuotationStatus = async (
  batchId: string
): Promise<IBulkQuoteStatusResponse> => {
  const response = await new HttpRequest().Get<IBulkQuoteStatusResponse>(
    `${baseUrl}${bulkQuotationUrl.status}${batchId}`
  );
  return response.data;
};
